/**
 * @desc 查询水泥消耗需求月计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthCementConsumptionResponse>> {
  return defHttp.post({
    url: '/web/plan/month/queryPlanCementConsumption',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthCementConsumptionResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/month/queryPlanCementConsumption',
    data,
  });
}
